export const BREAKPOINTS = {
  mobileS: '320px',
  tablet: '768px',
  laptop: '1024px',
  laptopL: '1440px'
}
